import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidDate: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-date',
		defaultMessage: 'Format for this date field is invalid',
		description: 'Field validation error for invalid date',
	},
	invalidNumber: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-number',
		defaultMessage: 'Format for this field is invalid. Values for this field must be numerical',
		description: 'Field validation error for invalid number',
	},
	invalidDateTime: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-date-time',
		defaultMessage: 'Format for this date time field is invalid',
		description: 'Field validation error for invalid date time',
	},
	emptySummary: {
		id: 'project-create-importer-upload-flow.common.utils.empty-summary',
		defaultMessage:
			"Summary field is empty. Make sure the summary is not left empty as it's a required field",
		description: 'Field validation error for an empty summary field',
	},
	invalidUserId: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-user-id',
		defaultMessage:
			'Use an email address when importing people into your project as approvers, assignees, reporters.',
		description: 'Field validation error for invalid user id',
	},
	invalidCascadingSelectFormat: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-cascading-select-format',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Format for this field is invalid. Try parentValue -> childValue to continue.',
		description: 'Field validation error for invalid cascading select format',
	},
	invalidCommentFormat: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-comment-format',
		defaultMessage: 'Format for this field is invalid. Try date-time;author;body to continue.',
		description: 'Field validation error for invalid cascading select format',
	},
	invalidWorkLogFormatWithLink: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-work-log-format-with-link',
		defaultMessage: 'Format for this field is invalid. {link}',
		description: 'Field validation error for invalid cascading select format',
	},
	invalidWorkLogFormatWithoutLink: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-work-log-format-without-link',
		defaultMessage: 'Format for this field is invalid.',
		description: 'Field validation error for invalid cascading select format',
	},
	invalidWorkLogFormatLinkText: {
		id: 'project-create-importer-upload-flow.common.utils.invalid-work-log-format-link-text',
		defaultMessage: 'Learn more about mapping fields.',
		description: 'Learn more link text',
	},
	genericErrors: {
		id: 'project-create-importer-upload-flow.common.utils.generic-errors',
		defaultMessage: 'Data for this field is invalid',
		description: 'Field validation error for generic errors',
	},
	trelloHeading: {
		id: 'project-create-importer-upload-flow.common.utils.trello-heading',
		defaultMessage: 'Select your Trello board',
		description: 'Select Trello Board heading',
	},
	trelloDescription: {
		id: 'project-create-importer-upload-flow.common.utils.trello-description',
		defaultMessage: 'Select the workspace and board you’d like to import data from.',
		description:
			'Description to inform user they should select the workspace and board to import data from',
	},
	trelloWorkspacesSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-workspaces-selector-label',
		defaultMessage: 'Trello workspace',
		description: 'Trello Workspace selector label',
	},
	trelloWorkspacesSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.trello-workspaces-selector-placeholder',
		defaultMessage: 'Select Trello workspace',
		description: 'Trello Workspace selector label',
	},
	trelloBoardsSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-boards-selector-label',
		defaultMessage: 'Trello board',
		description: 'Trello board selector label',
	},
	trelloBoardsSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.trello-boards-selector-placeholder',
		defaultMessage: 'Select Trello board',
		description: 'Trello board selector label',
	},
	trelloStarredWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-starred-workspaces-label',
		defaultMessage: 'Starred workspaces',
		description: 'Trello starred workspaces label',
	},
	trelloOtherWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-other-workspaces-label',
		defaultMessage: 'All workspaces',
		description: 'Trello all workspaces label',
	},
	trelloStarredBoardsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-starred-boards-label',
		defaultMessage: 'Starred boards',
		description: 'Trello starred boards label',
	},
	trelloOtherBoardsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.trello-other-boards-label',
		defaultMessage: 'All boards',
		description: 'Trello all boards label',
	},
	trelloStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.trello-stats-heading',
		defaultMessage: 'About this Board',
		description: 'About this Board heading for Trello stats',
	},
	trelloImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.trello-import-step-1-description',
		defaultMessage: 'Importing your Trello board data',
		description:
			'Description for the first step of the import where we import the users trello board',
	},
	trelloNoWorkspacesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.trello-no-workspaces-found-header',
		defaultMessage: 'No workspaces found',
		description: 'Header for the section message informing the user that there are no workspaces',
	},
	trelloNoWorkspacesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.trello-no-workspaces-found-description',
		defaultMessage: 'There are no workspaces linked to your account.',
		description:
			'Description for the section message informing the user that there are no workspaces found',
	},
	trelloErrorOccurredFetchingWorkspacesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.trello-error-occurred-fetching-workspaces-header',
		defaultMessage: 'We couldn’t load your workspaces',
		description:
			'Header for the section message informing the user that there was an error loading their workspaces',
	},
	trelloNoEntitiesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.trello-no-entities-found-header',
		defaultMessage: 'No boards found',
		description: 'Header for the section message informing the user that there are no boards found',
	},
	trelloNoEntitiesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.trello-no-entities-found-description',
		defaultMessage: 'Try selecting another workspace.',
		description:
			'Description for the section message informing the user that there are no boards found',
	},
	trelloErrorOccurredFetchingEntitiesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.trello-error-occurred-fetching-entities-header',
		defaultMessage: "We couldn't load your boards",
		description:
			'Header for the section message informing the user that there was an error loading their boards',
	},
	trelloNoAccountErrorHeader: {
		id: 'project-create-importer-upload-flow.common.utils.trello-no-account-error-header',
		defaultMessage: "We couldn't find your Trello account",
		description: 'Header for error screen when the user doesnt have a trello account',
	},
	asanaHeading: {
		id: 'project-create-importer-upload-flow.common.utils.asana-heading',
		defaultMessage: 'Select an Asana project',
		description: 'Select Asana Project heading',
	},
	asanaDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-description',
		defaultMessage: 'Select the workspace and project you’d like to import data from.',
		description:
			'Description to inform user they should select the workspace and project to import data from',
	},
	asanaWorkspacesSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-workspaces-selector-label',
		defaultMessage: 'Asana workspace',
		description: 'Asana Workspace selector label',
	},
	asanaWorkspacesSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.asana-workspaces-selector-placeholder',
		defaultMessage: 'Select an Asana workspace',
		description: 'Asana Workspace selector label',
	},
	asanaProjectsSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-projects-selector-label',
		defaultMessage: 'Asana project',
		description: 'Asana project selector label',
	},
	asanaProjectsSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.asana-projects-selector-placeholder',
		defaultMessage: 'Select an Asana project',
		description: 'Asana project selector label',
	},
	asanaStarredWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-starred-workspaces-label',
		defaultMessage: 'Starred workspaces',
		description: 'Asana starred workspaces label',
	},
	asanaOtherWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-other-workspaces-label',
		defaultMessage: 'All workspaces',
		description: 'Asana all workspaces label',
	},
	asanaStarredProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-starred-projects-label',
		defaultMessage: 'Starred projects',
		description: 'Asana starred projects label',
	},
	asanaOtherProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.asana-other-projects-label',
		defaultMessage: 'All projects',
		description: 'Asana all projects label',
	},
	asanaStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.asana-stats-heading',
		defaultMessage: 'About the Asana project',
		description: 'About this Project heading for Asana stats',
	},
	asanaImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.asana-import-step-1-description',
		defaultMessage: 'Importing Asana project data',
		description:
			'Description for the first step of the import where we import the users asana project',
	},
	asanaNoWorkspacesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.asana-no-workspaces-found-header',
		defaultMessage: 'No workspaces found',
		description: 'Header for the section message informing the user that there are no workspaces',
	},
	asanaNoWorkspacesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-no-workspaces-found-description',
		defaultMessage: 'There are no workspaces linked to your account.',
		description:
			'Description for the section message informing the user that there are no workspaces found',
	},
	asanaErrorOccurredFetchingWorkspacesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.asana-error-occurred-fetching-workspaces-header',
		defaultMessage: "We couldn't load your workspaces",
		description:
			'Header for the section message informing the user that there was an error loading their workspaces',
	},
	asanaNoEntitiesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.asana-no-entities-found-header',
		defaultMessage: 'No projects found',
		description:
			'Header for the section message informing the user that there are no projects found',
	},
	asanaNoEntitiesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-no-entities-found-description',
		defaultMessage: 'Try selecting another workspace.',
		description:
			'Description for the section message informing the user that there are no projects found',
	},
	asanaErrorOccurredFetchingEntitiesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.asana-error-occurred-fetching-entities-header',
		defaultMessage: "We couldn't load your projects",
		description:
			'Header for the section message informing the user that there was an error loading their projects',
	},
	asanaSearchEntitiesErrorOccurredDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-search-entities-error-occurred-description',
		defaultMessage:
			"We couldn't search for your projects. Try entering the project name once again.",
		description:
			'Description for the section message informing the user that there was an error searching their projects',
	},
	asanaLoadingMoreEntitiesErrorOccurredDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-loading-more-entities-error-occurred-description',
		defaultMessage: "We couldn't load your projects.",
		description:
			'Description for the error message informing the user that there was an error loading more projects',
	},
	asanaNoAccountErrorHeader: {
		id: 'project-create-importer-upload-flow.common.utils.asana-no-account-error-header',
		defaultMessage: "We couldn't find your Asana account",
		description: 'Header for error screen when the user doesnt have a asana account',
	},
	asanaReviewScreenDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-review-screen-description-spork',
		defaultMessage:
			"We've mapped your project and you're ready to import. Here’s how the Asana data will be imported into the Jira project. <link>Learn more about the project setup</link>",
		description: 'Description of Asana import review screen',
	},
	asanaFieldsTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-fields-tile-loading-description-spork',
		defaultMessage: 'Mapping your Asana fields to Jira',
		description: 'Description for Asana fields tile when the data is being loaded',
	},
	asanaFieldsMappingPageDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-fields-mapping-page-description-spork',
		defaultMessage:
			"We've automatically mapped your Asana data into system and custom fields in Jira. You can customize some fields that have other compatible field types. <link>More about field mapping</link>",
		description: 'Description of project field mapping page.',
	},
	asanaHierarchyTileDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-tile-description',
		defaultMessage: 'Sections from Asana are mapped to issue statuses',
		description: 'Description for Asana hierarchy tile',
	},
	asanaHierarchyMappingTileDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-mapping-tile-description',
		defaultMessage: 'Sections from Asana are mapped to {jiraHierarchyItem}',
		description: 'Description for Asana hierarchy tile',
	},
	asanaHierarchyTileLoadingDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-tile-loading-description',
		defaultMessage: 'Mapping your Asana section to issue statuses',
		description: 'Description for Asana hierarchy tile when data is loading',
	},
	asanaHierarchyStatusToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-status-tool-tip',
		defaultMessage:
			'Map your Section to Issue status if your tasks and subtasks are grouped by status such as Open, In progress or Done.',
		description: 'text of status field tooltip',
	},
	asanaHierarchyCategoryToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-category-tool-tip',
		defaultMessage: 'Map Section to Category when work is grouped using custom attributes.',
		description: 'text of category field tooltip',
	},
	asanaHierarchyEpicToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-epic-tool-tip',
		defaultMessage:
			'Map Section to Epic when grouping by large buckets of work that can then be broken down into smaller tasks.',
		description: 'text of epic tooltip',
	},
	asanaHierarchySubtaskToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-subtask-tool-tip',
		defaultMessage:
			"To maintain project hierarchy we'll import any nested subtasks as subtasks and link them to their respective subtasks.",
		description: 'text of subtask tooltip',
	},
	asanaDisabledFieldTooltip: {
		id: 'project-create-importer-upload-flow.common.utils.asana-disabled-field-tooltip',
		defaultMessage: 'This field is already mapped to another Asana field.',
		description:
			'Tooltip to indicate the reason that the field is disabled is that it is already mapped to another asana field',
	},
	asanaHierarchyPageDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-page-description-spork',
		defaultMessage:
			"Here’s how we've mapped your Asana data to Jira: <ul><li>Sections will be imported as issue statuses.</li><li>Tasks will be imported as issues. <link>Learn more about issues</link></li><li>Subtasks will be imported as subtasks and will be linked to their respective parent subtasks within each issue.</li></ul>",
		description: 'Description of project hierarchy page',
	},
	asanaHierarchyMappingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-hierarchy-mapping-description-spork',
		defaultMessage:
			"Here’s how we've mapped your Asana data to Jira. <link>More about project hierarchy in Jira</link>",
		description: 'Description of project hierarchy mapping page',
	},
	asanaMemberStats: {
		id: 'project-create-importer-upload-flow.common.utils.asana-member-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Member</header> <description>Will be added as a user to the new project</description>} other {<header>Members</header> <description>Will be added as users to the new project</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	asanaCardStats: {
		id: 'project-create-importer-upload-flow.common.utils.asana-card-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported as an issue in the new project</description>} other {<header>Tasks</header> <description>Will be imported as issues in the new project</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	asanaAddAccessTokenModalDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.asana-add-access-token-modal-description-spork',
		defaultMessage:
			'The token allows Jira to access your Asana data for import. To create a personal access token, log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy. {br}{br}Once you have your personal access token, paste it here to continue.',
		description: 'The modal body text',
	},
	asanaEditAccessTokenModalDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-edit-access-token-modal-description',
		defaultMessage:
			'To switch to a different Asana account, copy your personal access token for the account where you’d like to continue importing data from. Log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy. {br}{br}Once you have your personal access token, paste it here to continue.',
		description: 'The modal body text',
	},
	asanaChangeCurrentAccount: {
		id: 'project-create-importer-upload-flow.common.utils.asana-change-current-account',
		defaultMessage:
			'Not the project you’re looking for? <link>Switch to another Asana account </link>',
		description: 'Text for change Asana account',
	},
	asanaInvalidAccessTokenModalDescription: {
		id: 'project-create-importer-upload-flow.common.utils.asana-invalid-access-token-modal-description',
		defaultMessage:
			'Your personal access token has expired. To continue importing data you’ll need to regenerate a new token. To create a personal access token, log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy.{br}{br}Once you have your personal access token, paste it here to continue. This token won’t be valid here after 7 days.',
		description: 'The modal body text',
	},
	asanaUsersTileHeading: {
		id: 'project-create-importer-upload-flow.common.utils.asana-users-tile-heading',
		defaultMessage: 'Import all members from Asana project',
		description: 'Heading for the import users tile of Asana',
	},
	asanaUsersTileDescriptionUnchecked: {
		id: 'project-create-importer-upload-flow.common.utils.asana-users-tile-description-unchecked',
		defaultMessage:
			'Imported tasks will remain unassigned. Add assignees to tasks later from project settings',
		description: 'Description for asana users tile when unchecked',
	},
	mondayHeading: {
		id: 'project-create-importer-upload-flow.common.utils.monday-heading',
		defaultMessage: 'Select a monday board',
		description: 'Select monday board heading - Do not translate "monday" it is the product name.',
	},
	mondayDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-description',
		defaultMessage: 'Select the workspace and board you’d like to import data from.',
		description:
			'Description to inform user they should select the workspace and board to import data from',
	},
	mondayWorkspacesSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-workspaces-selector-label',
		defaultMessage: 'Monday workspace',
		description:
			'monday Workspace selector label - Do not translate "monday" it is the product name.',
	},
	mondayWorkspacesSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.monday-workspaces-selector-placeholder',
		defaultMessage: 'Select workspace',
		description: 'monday Workspace selector placeholder',
	},
	mondayFoldersSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-folders-selector-label',
		defaultMessage: 'Monday folder',
		description: 'monday Folder selector label - Do not translate "monday" it is the product name.',
	},
	mondayFoldersSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.monday-folders-selector-placeholder',
		defaultMessage: 'Select folder',
		description: 'monday Folder selector placeholder.',
	},
	mondayErrorOccurredFetchingFoldersHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-folders-header',
		defaultMessage: 'We couldn’t load your folders',
		description:
			'Header for the section message informing the user that there was an error loading their folders',
	},
	mondaySubfoldersSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-subfolders-selector-label',
		defaultMessage: 'Monday subfolder',
		description:
			'monday subfolder selector label - Do not translate "monday" it is the product name.',
	},
	mondaySubfoldersSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.monday-subfolders-selector-placeholder',
		defaultMessage: 'Select subfolder',
		description: 'monday subfolder selector placeholder.',
	},
	mondayProjectsSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-projects-selector-label',
		defaultMessage: 'Monday board',
		description: 'monday board selector label - Do not translate "monday" it is the product name.',
	},
	mondayProjectsSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.monday-projects-selector-placeholder',
		defaultMessage: 'Select board',
		description: 'monday board selector label',
	},
	mondayStarredWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-starred-workspaces-label',
		defaultMessage: 'Starred workspaces',
		description: 'monday starred workspaces label',
	},
	mondayOtherWorkspacesLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-other-workspaces-label',
		defaultMessage: 'All workspaces',
		description: 'monday all workspaces label',
	},
	mondayStarredProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-starred-projects-label',
		defaultMessage: 'Starred boards',
		description: 'monday starred boards label',
	},
	mondayOtherProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.monday-other-projects-label',
		defaultMessage: 'All boards',
		description: 'monday all boards label',
	},
	mondayStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.monday-stats-heading',
		defaultMessage: 'About this monday board',
		description:
			'About this monday board heading for monday stats - Do not translate "monday" it is the product name.',
	},
	mondayImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.monday-import-step-1-description',
		defaultMessage: 'Importing monday board',
		description:
			'Description for the first step of the import where we import the users monday board - Do not translate "monday" it is the product name.',
	},
	mondayNoWorkspacesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-workspaces-found-header',
		defaultMessage: 'No workspaces found',
		description: 'Header for the section message informing the user that there are no workspaces',
	},
	mondayNoWorkspacesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-workspaces-found-description',
		defaultMessage: 'There are no workspaces linked to your account.',
		description:
			'Description for the section message informing the user that there are no workspaces found',
	},
	mondayErrorOccurredFetchingWorkspacesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-workspaces-header',
		defaultMessage: 'We couldn’t load your workspaces',
		description:
			'Header for the section message informing the user that there was an error loading their workspaces',
	},
	mondayNoEntitiesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-entities-found-header',
		defaultMessage: 'No boards found',
		description: 'Header for the section message informing the user that there are no boards found',
	},
	mondayNoEntitiesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-entities-found-description',
		defaultMessage: 'Try selecting another workspace.',
		description:
			'Description for the section message informing the user that there are no boards found',
	},
	mondayNoEntitiesFoundWithFolderDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-entities-found-with-folder-description',
		defaultMessage: 'Try selecting another folder.',
		description:
			'Description for the section message informing the user that there are no boards found under this folder',
	},
	mondayNoEntitiesFoundWithSubfolderDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-entities-found-with-subfolder-description',
		defaultMessage: 'Try selecting another subfolder.',
		description:
			'Description for the section message informing the user that there are no boards found under this subfolder',
	},
	mondayErrorOccurredFetchingEntitiesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-entities-header',
		defaultMessage: "We couldn't load your boards",
		description:
			'Header for the section message informing the user that there was an error loading their boards',
	},
	mondayNoAccountErrorHeader: {
		id: 'project-create-importer-upload-flow.common.utils.monday-no-account-error-header',
		defaultMessage: "We couldn't find your monday account",
		description:
			'Header for error screen when the user doesnt have a monday account - Do not translate "monday" it is the product name.',
	},
	mondayReviewScreenDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-review-screen-description-spork',
		defaultMessage:
			'We’ve mapped the monday board to the new Jira project. Check the details to see how everything has been mapped, make any changes, and then confirm the import. <link>More about project setup</link>',
		description:
			'Description of monday import review screen - Do not translate "monday" it is the product name.',
	},
	mondayFieldsTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-fields-tile-loading-description-spork',
		defaultMessage: 'Mapping your monday fields to Jira',
		description:
			'Description for monday fields tile when the data is being loaded - Do not translate "monday" it is the product name.',
	},
	mondayFieldsMappingPageDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-fields-mapping-page-description-spork',
		defaultMessage:
			"We've automatically mapped your monday data into system and custom fields in Jira. You can customize some fields that have other compatible field types. <link>More about field mapping</link>",
		description:
			'Description of field mapping page - Do not translate "monday" it is the product name.',
	},
	mondayHierarchyTileDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-tile-description-spork',
		defaultMessage: 'Groups in monday are mapped as epics in Jira',
		description:
			'Description for monday hierarchy tile - Do not translate "monday" it is the product name.',
	},
	mondayHierarchyMappingTileDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-mapping-tile-description-spork',
		defaultMessage: 'Groups in monday are mapped as {jiraHierarchyItem} in Jira',
		description:
			'Description for monday hierarchy tile - Do not translate "monday" it is the product name',
	},
	mondayHierarchyTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-tile-loading-description-spork',
		defaultMessage: 'Mapping your monday Groups in monday as epics in Jira',
		description:
			'Description for monday hierarchy tile when the data is loading - Do not translate "monday" it is the product name.',
	},
	mondayDisabledFieldTooltip: {
		id: 'project-create-importer-upload-flow.common.utils.monday-disabled-field-tooltip',
		defaultMessage: 'This field is already mapped to another monday field.',
		description:
			'Tooltip to indicate the reason that the field is disabled is that it is already mapped to another monday field',
	},
	mondayHierarchyStatusToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-status-tool-tip',
		defaultMessage:
			'Map your Group to Issue status if your tasks and subtasks are grouped by status such as Open, In progress or Done.',
		description: 'text of status field tooltip',
	},
	mondayHierarchyCategoryToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-category-tool-tip',
		defaultMessage: 'Map Group to Category when work is grouped using custom attributes.',
		description: 'text of category field tooltip',
	},
	mondayHierarchyEpicToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-epic-tool-tip',
		defaultMessage:
			'Map Group to Epic when grouping by large buckets of work that can then be broken down into smaller tasks.',
		description: 'text of epic tooltip',
	},
	mondayHierarchyPageDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-page-description-spork',
		defaultMessage:
			'To match the hierarchy of your monday project we’re mapping the following: <ul><li>Groups will be imported as epics.</li><li>Items will be imported as issues.</li><li> Subitems will be imported as subtasks.</li></ul><link>More about project hierarchy in Jira</link>',
		description:
			'Description of project hierarchy page - Do not translate "monday" it is the product name.',
	},
	mondayHierarchyMappingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-hierarchy-mapping-description-spork',
		defaultMessage:
			"Here’s how we've mapped your monday data to Jira. <link>More about project hierarchy in Jira</link>",
		description: 'Description of project hierarchy mapping page',
	},
	mondayUsersTileHeading: {
		id: 'project-create-importer-upload-flow.common.utils.monday-users-tile-heading',
		defaultMessage: 'Import all members from monday board',
		description:
			'Heading for the import users tile - Do not translate "monday" it is the product name.',
	},
	mondayUsersTileDescriptionUnchecked: {
		id: 'project-create-importer-upload-flow.common.utils.monday-users-tile-description-unchecked',
		defaultMessage:
			'Imported tasks will remain unassigned. Add assignees to tasks later from project settings',
		description: 'Description for monday users tile when unchecked',
	},
	mondayCardStats: {
		id: 'project-create-importer-upload-flow.common.utils.monday-card-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported as an issue in the new project.</description>} other {<header>Tasks</header> <description>Will be imported as issues in the new project.</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	mondayCardStatsShort: {
		id: 'project-create-importer-upload-flow.common.utils.monday-card-stats-short',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Item</header> <description>will be created as an issue</description>} other {<header>Items</header> <description>will be created as issues</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	mondayUsersStatsShort: {
		id: 'project-create-importer-upload-flow.common.utils.monday-users-stats-short',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Member</header> <description>will be invited as a member</description>} other {<header>Members</header> <description>will be invited as members</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	mondayPreOAuthModalTitle: {
		id: 'project-create-importer-upload-flow.common.utils.monday-pre-o-auth-modal-title',
		defaultMessage: 'Connect to your monday account',
		description: 'pre oAuth modal title text - Do not translate "monday" it is the product name.',
	},
	mondayPreOAuthModalDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-pre-o-auth-modal-description',
		defaultMessage:
			'We’ll need to get authorization from you to connect to your monday account so you can begin importing data. Before you proceed, make sure you <link>install the monday importer app</link>.',
		description: 'pre oAuth modal body text - Do not translate "monday" it is the product name.',
	},
	mondayOAuthUnsuccessFlagTitle: {
		id: 'project-create-importer-upload-flow.common.utils.monday-o-auth-unsuccess-flag-title',
		defaultMessage: "Couldn't connect to your monday account",
		description:
			'OAuth unsuccess flag title text - Do not translate "monday" it is the product name.',
	},
	mondayOAuthUnsuccessFlagDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-o-auth-unsuccess-flag-description',
		defaultMessage:
			'Try reauthorizing your account. If you continue experiencing issues, <link>contact your admin</link>.',
		description: 'OAuth unsuccess flag body text',
	},
	mondayAddAccessTokenModalDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.monday-add-access-token-modal-description-spork',
		defaultMessage:
			'This token will allow Jira to access your monday data for import. To create a personal access token, log into your monday account > select your avatar/profile picture > Developers > My access tokens > Copy. <link>More about generating a token in monday</link> {br}{br}Once you have your personal access token, paste it here to continue.',
		description: 'The modal body text',
	},
	mondayEditAccessTokenModalDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-edit-access-token-modal-description',
		defaultMessage:
			'To switch to a different monday account, copy your personal access token for the account where you’d like to continue importing data from. Log into the monday account > select your avatar/profile picture > Developers > My access tokens > Copy.{br} {br}Once you have your personal access token, paste it here to continue.',
		description: 'The modal body text',
	},
	mondayChangeCurrentAccount: {
		id: 'project-create-importer-upload-flow.common.utils.monday-change-current-account',
		defaultMessage:
			'Not the board you’re looking for? <link>Switch to another monday account </link>',
		description:
			'Text for change monday account - Do not translate "monday" it is the product name.',
	},
	mondayLoadingSiteNameErrorOccurredDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-loading-site-name-error-occurred-description',
		defaultMessage: 'We’re unable to find this account. Retry or switch to another monday account.',
		description:
			'Description for the error message informing the user that there was an error loading site name',
	},
	mondayInvalidAccessTokenModalDescription: {
		id: 'project-create-importer-upload-flow.common.utils.monday-invalid-access-token-modal-description',
		defaultMessage:
			'Your personal access token has expired. To continue importing data you’ll need to regenerate a new token. To create a new token log into your monday account > select your avatar/profile picture > Developers > My access tokens > Regenerate > Copy.{br}{br}Once you have your personal access token, paste it here to continue. This token won’t be valid here after 7 days.',
		description: 'The modal body text',
	},
	memberStats: {
		id: 'project-create-importer-upload-flow.common.utils.member-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>User</header> <description>This user is a member of the selected board.</description>} other {<header>Users</header> <description>These users are members of the selected board.</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	jiraHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-heading',
		defaultMessage: 'Select a software project',
		description: 'Select Jira Board heading',
	},
	jiraDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.jira-description-spork',
		defaultMessage: "Select which software project you'd like to import data from.",
		description: 'Description to inform user they should select the project to import data from',
	},
	jiraProjectSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.jira-project-selector-label',
		defaultMessage: 'Software project',
		description: 'Jira project selector label',
	},
	jiraProjectSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.jira-project-selector-placeholder',
		defaultMessage: 'Select project',
		description: 'Jira project selector label',
	},
	jiraStarredProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.jira-starred-projects-label',
		defaultMessage: 'Starred projects',
		description: 'Jira starred project label',
	},
	jiraOtherProjectsLabel: {
		id: 'project-create-importer-upload-flow.common.utils.jira-other-projects-label',
		defaultMessage: 'All projects',
		description: 'Jira all projects label',
	},
	jiraStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-stats-heading',
		defaultMessage: 'About this software project',
		description: 'About this Board heading for Jira stats',
	},
	jiraProjectCreateHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-project-create-heading',
		defaultMessage: 'Create a business project',
		description: 'The header for create project screen',
	},
	jiraReviewScreenDescriptionComplexspork: {
		id: 'project-create-importer-upload-flow.common.utils.jira-review-screen-description-complexspork',
		defaultMessage:
			"We've mapped the software project to the new business project. Check the details to see how everything is mapped, make any changes, then confirm the import. <link>More about the project setup</link>",
		description: 'Description of Jira import review screen',
	},
	jiraFieldsTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.jira-fields-tile-loading-description-spork',
		defaultMessage: 'Mapping your software project into business project fields',
		description: 'Description for Jira fields tile when the data is being loaded',
	},
	jiraFieldsMappingPageDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-description',
		defaultMessage:
			"We've automatically mapped the software project data into system and custom fields in your business project. You can customize some fields that have other compatible field types.",
		description: 'Description of project field mapping page.',
	},
	jiraFieldsMappingPageDisclaimer: {
		id: 'project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-disclaimer',
		defaultMessage: 'Some fields may not be supported by business projects. <link>Read more</link>',
		description:
			'Additional text on project field mapping page if there are some conditions around the mapped fields for Jira software to Jira business projects',
	},
	jiraFieldsMappingPageIssueTypesMessage: {
		id: 'project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-issue-types-message',
		defaultMessage: 'Issue types:',
		description: 'The label for issue type tabs',
	},
	jiraFieldsTileInfoDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-fields-tile-info-description',
		defaultMessage: 'Some fields may not be supported by business projects.',
		description: 'Additional information for Jira fields tile regarding unsupported fields',
	},
	jiraUsersTileHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-users-tile-heading',
		defaultMessage: 'Import all users',
		description: 'Heading for the import users tile of Jira',
	},
	jiraUserTileDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-user-tile-description',
		defaultMessage:
			"Anyone assigned, added in a comment, or mentioned anywhere on the project. Imported users won't be notified.",
		description: 'Description for jira import users tile',
	},
	jiraUsersTileDescriptionUnchecked: {
		id: 'project-create-importer-upload-flow.common.utils.jira-users-tile-description-unchecked',
		defaultMessage:
			'Imported data will remain unassigned. You can add assignees to issues later from project settings',
		description: 'Description for jira users tile when unchecked',
	},
	jiraDisabledFieldTooltip: {
		id: 'project-create-importer-upload-flow.common.utils.jira-disabled-field-tooltip',
		defaultMessage: 'This field is already mapped to another software field.',
		description:
			'Tooltip to indicate the reason that the field is disabled is that it is already mapped to another Jira field',
	},
	jiraImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.jira-import-step-1-description',
		defaultMessage: 'Importing your software project',
		description:
			'Description for the first step of the import where we import the users jira board',
	},
	jiraNoEntitiesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.jira-no-entities-found-header',
		defaultMessage: 'No projects found',
		description:
			'Header for the section message informing the user that there are no projects found',
	},
	jiraNoEntitiesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-no-entities-found-description',
		defaultMessage: 'There are no projects in your account.',
		description:
			'Description for the section message informing the user that there are no projects found',
	},
	jiraErrorOccurredFetchingEntitiesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.jira-error-occurred-fetching-entities-header',
		defaultMessage: "We couldn't load your projects",
		description:
			'Header for the section message informing the user that there was an error loading their projects',
	},
	cardStats: {
		id: 'project-create-importer-upload-flow.common.utils.card-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Card</header> <description>This is the active card on the selected board.</description>} other {<header>Cards</header> <description>These are the active cards on the selected board.</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	cardStatsShort: {
		id: 'project-create-importer-upload-flow.common.utils.card-stats-short',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Card</header> <description>will be created as an issue</description>} other {<header>Cards</header> <description>will be created as issues</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	usersStatsShort: {
		id: 'project-create-importer-upload-flow.common.utils.users-stats-short',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>User</header> <description>will be invited as a member</description>} other {<header>Users</header> <description>will be invited as members</description>}}',
		description: 'Member stats shown in select third party entity screen',
	},
	clickupHeading: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-heading',
		defaultMessage: 'Select a ClickUp list',
		description: 'Select ClickUp space heading',
	},
	clickupDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-description',
		defaultMessage: "We'll import the details from ClickUp to your new project. ",
		description:
			'Description to inform user they should select the workspace and list to import data from',
	},
	clickupWorkspaceSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-workspace-selector-label',
		defaultMessage: 'ClickUp workspace',
		description: 'ClickUp workspace selector label',
	},
	clickupWorkspaceSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-workspace-selector-placeholder',
		defaultMessage: 'Select workspace',
		description: 'ClickUp workspace selector placeholder',
	},
	clickupNoWorkspacesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-workspaces-found-header',
		defaultMessage: 'No workspaces found',
		description: 'Header for the section message informing the user that there are no workspaces',
	},
	clickupSpaceSelector: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-space-selector',
		defaultMessage: 'ClickUp space',
		description: 'ClickUp space selector label',
	},
	clickupSpaceSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-space-selector-placeholder',
		defaultMessage: 'Select space',
		description: 'ClickUp space selector placeholder',
	},
	clickupErrorOccurredFetchingSpacesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-spaces-header',
		defaultMessage: 'We couldn’t load your spaces',
		description:
			'Header for the section message informing the user that there was an error loading their spaces',
	},
	clickupNoSpacesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-spaces-found-header',
		defaultMessage: 'No spaces found',
		description: 'Header for the section message informing the user that there are no spaces found',
	},
	clickupNoSpacesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-spaces-found-description',
		defaultMessage: 'There are no spaces linked to your account.',
		description:
			'Description for the section message informing the user that there are no spaces found',
	},
	clickupFolderSelector: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-folder-selector',
		defaultMessage: 'ClickUp folder',
		description: 'ClickUp folder selector label',
	},
	clickupFolderSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-folder-selector-placeholder',
		defaultMessage: 'Select folder',
		description: 'ClickUp folder selector placeholder',
	},
	clickupListSelector: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-list-selector',
		defaultMessage: 'ClickUp list',
		description: 'ClickUp list selector label',
	},
	clickupListSelectorPlaceholder: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-list-selector-placeholder',
		defaultMessage: 'Select list',
		description: 'ClickUp list selector label',
	},
	clickupNoEntitiesFoundHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-entities-found-header',
		defaultMessage: 'No lists found',
		description: 'Header for the section message informing the user that there are no lists found',
	},
	clickupNoEntitiesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-entities-found-description',
		defaultMessage: 'Try selecting another space.',
		description:
			'Description for the section message informing the user that there are no lists found',
	},
	clickupNoEntitiesFoundWithFolderDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-entities-found-with-folder-description',
		defaultMessage: 'Try selecting another folder.',
		description:
			'Description for the section message informing the user that there are no lists found under this folder',
	},
	clickupErrorOccurredFetchingEntitiesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-entities-header',
		defaultMessage: "We couldn't load your lists",
		description:
			'Header for the section message informing the user that there was an error loading their lists',
	},
	clickupNoWorkspacesFoundDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-no-workspaces-found-description',
		defaultMessage: 'There are no workspaces linked to your account.',
		description:
			'Description for the section message informing the user that there are no workspaces found',
	},
	clickupErrorOccurredFetchingWorkspacesHeader: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-workspaces-header',
		defaultMessage: 'We couldn’t load your workspaces',
		description:
			'Header for the section message informing the user that there was an error loading their workspaces',
	},
	clickupStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-stats-heading',
		defaultMessage: 'About this ClickUp list',
		description: 'ClickUp list heading for ClickUp stats',
	},
	clickupReviewScreenDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-review-screen-description-spork',
		defaultMessage:
			'Take a minute to review the details we’re about to import to your new project. <link>Read more about project setup</link>',
		description: 'Description of ClickUp import review screen',
	},
	clickupFieldsTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-fields-tile-loading-description-spork',
		defaultMessage: 'Mapping your ClickUp fields to Jira',
		description: 'Description for ClickUp fields tile when the data is being loaded',
	},
	clickupFieldsMappingPageDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-fields-mapping-page-description',
		defaultMessage:
			'We’ve automatically mapped your list fields. Some field types may be customizable. <link>Read more about field mapping</link>',
		description: 'Description of project field mapping page.',
	},
	clickupUsersTileHeading: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-users-tile-heading',
		defaultMessage: 'Import users',
		description: 'Heading for the import users tile for ClickUp',
	},
	clickupUserTileDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-user-tile-description',
		defaultMessage: "Imported users won't be notified",
		description: 'Description for ClickUp users tile',
	},
	clickupUsersTileDescriptionUnchecked: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-users-tile-description-unchecked',
		defaultMessage:
			'Imported tasks will remain unassigned. Add users to tasks later from project settings',
		description: 'Description for ClickUp users tile when unchecked',
	},
	clickupAttachmentTileEnabledDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-attachment-tile-enabled-description',
		defaultMessage: 'Importing attachments may take extra time',
		description:
			'Description for the import attachment tile indicating that it will take extra time',
	},
	clickupImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-import-step-1-description',
		defaultMessage: 'Importing ClickUp list',
		description: 'Description for the first step of the import where we import ClickUp space',
	},
	clickupImportStep1DescriptionMultiLists: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-import-step-1-description-multi-lists',
		defaultMessage: 'Importing ClickUp lists',
		description: 'Description for the first step of the import where we import ClickUp space',
	},
	clickupHierarchyMappingTileDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-hierarchy-mapping-tile-description-spork',
		defaultMessage: 'ClickUp lists are mapped as {jiraHierarchyItem} in Jira',
		description:
			'Description for ClickUp hierarchy tile - Do not translate "ClickUp" it is the product name',
	},
	clickupHierarchyTileLoadingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-hierarchy-tile-loading-description-spork',
		defaultMessage: 'Mapping your lists in ClickUp as epics in Jira',
		description:
			'Description for ClickUp hierarchy tile when the data is loading - Do not translate "ClickUp" it is the product name.',
	},
	clickupHierarchyEpicToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-hierarchy-epic-tool-tip',
		defaultMessage:
			'An epic is a large body of work that can be broken down into a number of smaller tasks.',
		description: 'text of epic tooltip',
	},
	clickupHierarchyMappingDescriptionSpork: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-hierarchy-mapping-description-spork',
		defaultMessage:
			"Here’s how we've mapped your ClickUp list to Jira. <link>Read more about project hierarchy</link>",
		description: 'Description of project hierarchy mapping page',
	},
	clickupHierarchySubtaskToolTip: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-hierarchy-subtask-tool-tip',
		defaultMessage: 'Nested subtasks will be imported as subtasks, and link to their parent task.',
		description: 'text of subtask tooltip',
	},
	clickupRateLimitWarning: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-rate-limit-warning',
		defaultMessage:
			'Time to import your list will depend on your <link>ClickUp plan and rate limit</link>.',
		description: 'Warning message for ClickUp rate limit',
	},
	clickupCardStats: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-card-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported from the selected list.</description>} other {<header>Tasks</header> <description>Will be imported from the selected list.</description>}}',
		description: 'Tasks stats shown in select third party entity screen',
	},
	clickupCardStatsShort: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-card-stats-short',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>will be created as an issue</description>} other {<header>Tasks</header> <description>will be created as issues</description>}}',
		description: 'Tasks stats shown in select third party entity screen',
	},
	clickupStatsInfo: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-stats-info',
		defaultMessage: 'Tasks in another list will not be imported.',
		description: 'Info message for ClickUp about tasks in another list will not be imported',
	},
	clickupStatsInfoMultiList: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-stats-info-multi-list',
		defaultMessage: 'Tasks that originate in other lists will not be imported.',
		description: 'Info message for ClickUp about tasks in other lists will not be imported',
	},
	clickupOAuthUnsuccessFlagTitle: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-o-auth-unsuccess-flag-title',
		defaultMessage: "Couldn't connect to your ClickUp account",
		description: 'OAuth unsuccess flag title text',
	},
	clickupOAuthUnsuccessFlagDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-o-auth-unsuccess-flag-description',
		defaultMessage:
			'Try reauthorizing your account. If you continue experiencing issues, <link>contact your admin</link>.',
		description: 'OAuth unsuccess flag body text',
	},
	clickupMultiListInfo: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-multi-list-info',
		defaultMessage:
			'The more lists you import, the longer it may take. <link>Read more about importing lists</link>',
		description: 'Info message for ClickUp multi list import',
	},
	clickupStatusMappingDescription: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-status-mapping-description',
		defaultMessage:
			"We've automatically mapped your statuses. Select a field to change a status, or start typing to add your own. <link>Read more about status mapping</link>",
		description: 'text of status mapping page description',
	},
	clickupStatusMappingEntityName: {
		id: 'project-create-importer-upload-flow.common.utils.clickup-status-mapping-entity-name',
		defaultMessage: 'ClickUp lists:',
		description: 'The label for lists tabs',
	},
	jiraBusinessHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-heading',
		defaultMessage: 'Select a project to import',
		description:
			'Page heading for first step of the import from Jira business to software projects, where users select the business project they wish to import',
	},
	jiraBusinessDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-description',
		defaultMessage:
			"We'll import the details, supported fields, and issues to your new project. <link>Read more about importing projects</link>",
		description:
			'Description on the first step of the import from Jira business to software projects, to inform user they should select the project to import data from',
	},
	jiraBusinessProjectSelectorLabel: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-project-selector-label',
		defaultMessage: 'Business project',
		description:
			'Label for the field which lets the user select a Jira business project, on the first step of the import from Jira business to software projects',
	},
	jiraBusinessStatsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-stats-heading',
		defaultMessage: 'About your business project',
		description:
			'Heading for the stats section on the first step of the import from Jira business to software projects. This section shows task stats when the user selects a project',
	},
	jiraBusinessCardStats: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-card-stats',
		defaultMessage:
			'<stats>{statistic}</stats> {statistic, plural, one {<header>Issue</header> <description>Will be imported from the selected project</description>} other {<header>Issues</header> <description>Will be imported from the selected project</description>}}',
		description:
			'Content showing the number of issues in the project selected by the user on the first step of the import from Jira business to software projects.',
	},
	jiraBusinessReviewScreenDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-review-screen-description',
		defaultMessage:
			"Take a minute to review the details we're about to import to your new project. <link>Read more about project mapping</link>",
		description:
			'Description shown on the review step of the import from Jira business to software projects',
	},
	jiraBusinessFieldsTileLoadingDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-fields-tile-loading-description',
		defaultMessage: 'Mapping your project fields',
		description:
			'Description for Jira field mapping tile when the data is being loaded, on the review step of the importer from Jira business to software projects.',
	},
	jiraBusinessUserTileDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-user-tile-description',
		defaultMessage: "Users won't be notified",
		description:
			'Description for import users tile, on the review step of the importer from Jira business to software projects, which informs the user that imported users will not be notified',
	},
	jiraBusinessFieldsMappingPageDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-fields-mapping-page-description',
		defaultMessage:
			"We've automatically mapped your new project fields. Some fields may be customizable. <link>Read more about field mapping</link>",
		description:
			'Description of project field mapping page on the review step of the importer from Jira business to software projects.',
	},
	jiraBusinessFieldsMappingPageDisclaimer: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-fields-mapping-page-disclaimer',
		defaultMessage: 'Some fields may not be supported by software projects. <link>Read more</link>',
		description:
			'Additional text on project field mapping page if there are some conditions around the mapped fields for Jira business to Jira software projects.',
	},
	jiraBusinessDisabledFieldTooltip: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-disabled-field-tooltip',
		defaultMessage: 'This field is already mapped to another business field.',
		description:
			'This is a tooltip on non-editable fields in the field mapping screen in the review step of the import, which indicates the reason that the field is disabled is that it is already mapped to another Jira field',
	},
	jiraBusinessImportStep1Description: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-import-step-1-description',
		defaultMessage: 'Mapping project fields',
		description:
			'This text is shown on the final step of the import, which shows the progress of the import after it has started. This is the text indicating the first step of the import process, where the jira business project details are imported.',
	},
	usersTileWarningDescription: {
		id: 'project-create-importer-upload-flow.common.utils.users-tile-warning-description',
		defaultMessage:
			'You don’t have permission to invite new users. Any information provided about new users will not be imported.',
		description: 'Warning message for user tile',
	},
	jiraBusinessFieldsTileInfoDescription: {
		id: 'project-create-importer-upload-flow.common.utils.jira-business-fields-tile-info-description',
		defaultMessage: 'Some fields may not be supported by software projects.',
		description: 'Additional information for Jira fields tile regarding unsupported fields',
	},
});
